import React from 'react';
import OceanBackground from '../components/OceanBackground';

const OceanTestPage: React.FC = () => <OceanBackground />;

export default OceanTestPage;
